// extracted by mini-css-extract-plugin
export var formContainer = "styles-module__formContainer___G_K1N";
export var header = "styles-module__header___JtgOv";
export var formSection = "styles-module__formSection___X45r7";